export default "__VITE_ASSET__82ac417c__"